import { render, staticRenderFns } from "./FaceVerificationModal.vue?vue&type=template&id=e3a3fef0&scoped=true"
import script from "./FaceVerificationModal.vue?vue&type=script&lang=js"
export * from "./FaceVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./FaceVerificationModal.vue?vue&type=style&index=0&id=e3a3fef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a3fef0",
  null
  
)

export default component.exports